import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://0d6ddf77b001b3b3053ec0d183b9b0e2@o4511208653127680.ingest.de.sentry.io/4511208936243280",
  debug: false,
  environment: "production",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});